import React from "react";
import {
  BsTwitter,
  BsInstagram,
  BsLinkedin,
  BsFillPersonLinesFill,
} from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div title="Resume">
        <a
          target="_blank"
          href="https://drive.google.com/file/d/1yr_nDXQCDK1ix1TTncduo0rZfdm5No_T/view?usp=sharing"
          rel="noreferrer"
        >
          <BsFillPersonLinesFill />
        </a>
      </div>
      <div>
        <a
          target="_blank"
          href="https://www.linkedin.com/in/sumeet-shinde-34076a1a4/"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a
          target="_blank"
          href="https://twitter.com/sam99sumit"
          rel="noreferrer"
        >
          <BsTwitter />
        </a>
      </div>
      <div>
        <a
          target="_blank"
          href="https://www.facebook.com/sumeet.shinde.946"
          rel="noreferrer"
        >
          <FaFacebookF />
        </a>
      </div>
      <div>
        <a
          target="_blank"
          href="https://www.instagram.com/s__u__m__e__t/"
          rel="noreferrer"
        >
          <BsInstagram />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
